// extracted by mini-css-extract-plugin
export default {"body":"TableBody-module__body__k6FnL"};